import React from 'react';
import '../css/seminar.css';
import avatar1 from "../images/avatar1.png";
import avatar2 from "../images/avatar2.png";
import avatar3 from "../images/avatar3.png";
import avatar4 from "../images/avatar4.png";

export default function Seminar() {
    return (
        <div className="reviewsContainer">
            <div className="reviewsHeader">
                <h1 className="reviewsInfoHeader">Atsiliepimai</h1>
            </div>
            <div className="reviewsInfo">
                <div className="gird-item review1">
                    <div className="review">
                        <img className="contacts-img" src={avatar2} alt="avatar2"></img>
                        <div>
                            <h1>Deimantė</h1>
                            <p>Nežinomybė visada sukelia
                                baimę ir pyktį. Žinios atneša
                                laisvę. Ačiū, po susitikimo gavau
                                visus atsakymus į man rūpimus
                                finansinius klausimus. Žinios
                                palengvina priimti tolimesnius
                                sprendimus. Kontaktus
                                išsisaugau, jei kils klausimų, žinau
                                kur kreiptis. </p>
                            <a href="https://www.instagram.com/stories/highlights/18037320289677031/" target="_blank" rel="noreferrer">
                                Nuoroda į atsiliepimą (Instagram)
                            </a>
                        </div>
                    </div>
                </div>
                <div className="gird-item review2">
                    <div className="review">
                        <img className="contacts-img" src={avatar1} alt="avatar1"></img>
                        <div>
                            <h1>Anoniminis atsiliepimas</h1>
                            <p>Didelis didelis dėkui Erikui už
                                konsultacijas, kuriuose atskleidė
                                investavimo būdus, paaiškino,
                                nukreipė tinkama linkme! Labai
                                šiltas ir "Savas" žmogus
                                Rekomenduoju!!!</p>
                            <a href="https://www.instagram.com/stories/highlights/18037320289677031/" target="_blank" rel="noreferrer">
                                Nuoroda į atsiliepimą (Instagram)
                            </a>
                        </div>
                    </div>
                </div>
                <div className="gird-item review3">
                    <div className="review">
                        <img className="contacts-img" src={avatar2} alt="avatar2"></img>
                        <div>
                            <h1>Anoniminis atsiliepimas</h1>
                            <p>Labai noėčiau padėkoti Erikui už taip puikiai ir aiškiai pravestą konsultaciją!
                                Viskas buvo suprantam ir aišku. Ačiū Jums labai už susitikimą ir konsultaciją!
                                Rekomenduoju!!!!</p>
                            <a href="https://www.instagram.com/stories/highlights/18037320289677031/" target="_blank" rel="noreferrer">
                                Nuoroda į atsiliepimą (Instagram)
                            </a>
                        </div>
                    </div>
                </div>
                <div className="gird-item review4">
                    <div className="review">
                        <img className="contacts-img" src={avatar3} alt="avatar3"></img>
                        <div>
                            <h1>Anoniminis atsiliepimas</h1>
                            <p>Ačiū Erikui, už suteiktą galimybę
                                įgauti naujų žinių ir praturtinti
                                savo pasaulėžiūrą temomis kurios
                                mane domina. Ačiū dar kartą,
                                rekomenduoju!</p>
                            <a href="https://www.instagram.com/stories/highlights/18037320289677031/" target="_blank" rel="noreferrer">
                                Nuoroda į atsiliepimą (Instagram)
                            </a>
                        </div>
                    </div>
                </div>
                <div className="gird-item review5">
                    <div className="review">
                        <img className="contacts-img" src={avatar4} alt="avatar4"></img>
                        <div>
                            <h1>Anoniminis atsiliepimas</h1>
                            <p>Labai patiko informacija ir jau
                                galėsiu atskirti sukčius nuo
                                normalių. Dėl informacijos labai
                                dėkingas ir labai naudinga.</p>
                            <a href="https://www.instagram.com/stories/highlights/18037320289677031/" target="_blank" rel="noreferrer">
                                Nuoroda į atsiliepimą (Instagram)
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}